const f = {
  color: {
    bg: "#1d2b36ff",
    title: "#47a3ffff",
    badge: {
      bg: "#405261ff",
      text: "#ffffffff"
    }
  }
};
export {
  f as tooltip
};
